module.exports = require("lodash/isEmpty");


//////////////////
// WEBPACK FOOTER
// external "lodash/isEmpty"
// module id = 67
// module chunks = 0